export default function isFlexSupported() {
    if (typeof window !== 'undefined' && window.document && window.document.documentElement) {
        var documentElement = window.document.documentElement;

        return 'flex' in documentElement.style || 'webkitFlex' in documentElement.style || 'Flex' in documentElement.style || 'msFlex' in documentElement.style;
    }
    return false;
}


//////////////////
// WEBPACK FOOTER
// ./~/antd/es/_util/isFlexSupported.js
// module id = 1319
// module chunks = 0